import { parseGpx, type RawTelemetryData, type Device } from '@pitbrain/shared'
import useApi from '../../../api/useApi'
import ConfigurationContext from '../../../core/providers/ConfigurationContext'
import { useContext } from 'react'
import { useBaseProcessor } from '../useBaseProcessor'
import { type UploadFormat } from '../UploadFormat'
import { readFileAsText } from './readFileAsText'

export const useGpxProcessor = (): UploadFormat => {
  const bffConfig = useContext(ConfigurationContext)
  const api = useApi(bffConfig)
  const { getFirstCoordinate, processAndCreateSession } = useBaseProcessor()
  const { error: apiError } = api

  const processFile = async (file: File, sessionId: string) => {
    const gps = parseGpx(await readFileAsText(file))
    if (gps.length === 0) {
      throw new Error(
        'No track points with a position and time were found in the GPX file.'
      )
    }

    const rawTelemetry: RawTelemetryData = {
      gps,
      recordingStartTime: gps[0].timestamp,
      device: { deviceName: 'Unknown', deviceVersion: '1.0' },
    }
    const firstCoordinate = getFirstCoordinate(rawTelemetry)
    if (firstCoordinate == null) return

    const track = await api.trackApi.findTrack(firstCoordinate)
    const device: Device = { name: 'Unknown', version: '1.0' }

    await processAndCreateSession(
      rawTelemetry,
      sessionId,
      track,
      { hasLeanAngle: false, hasVideo: false },
      file.name,
      device
    )
  }

  return {
    extensions: ['.GPX'],
    keepsFileAsSource: true,
    processFile,
    error: apiError,
  }
}
